import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import moment from 'moment-with-locales-es6'

import './ReviewReservationPage.css'

import { DomainContext, CORPORATE_TYPE_ID, getDriversFirstName } from '../../domain-repository/DomainRepository'
import { GroupsImagesContext } from '../../domain-repository/GroupsImagesRepository'

import { FooterWithPrice } from '../../components/Footer'
import ReviewStations from '../../components/review/ReviewStations'
import ReviewVehicleProperties from '../../components/review/ReviewVehicleProperties'
import ReviewBanner from '../../components/review/ReviewBanner'
import withLang from '../../withLang'
import TrackingPage from '../../components/TrackingPage'
import { getPages } from '../../services/Pages'
import { getInvalidBirthdatesConfigurations } from '../../services/BirthdatesConfigurations'
import { isSafari } from '../../utils/utils'
import { useDisableBodyScroll } from '../../utils/useDisableBodyScroll'

function ReviewReservationPage(props) {
  const {
    reservation,
    reservationExtras,
    getExcessForExtras,
    rentalAgreementQuoteValue,
    setDriverInfoHasClickedBack,
    setDriverInfoEditMode,
    appFlowConfigs,
    isCorporate,
    groupsDetails,
    flowNextRoute,
    setPages,
    setInvalidBirthdates,
    stationsConfigurations,
    localizationAssets,
  } = useContext(DomainContext)

  const safeReservation = reservation || {}

  const groupInfo = groupsDetails.find(g => g.id === safeReservation.GroupID) || {}

  const { groupsConfigurations } = useContext(GroupsImagesContext)

  const { t, i18n } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (safeReservation) {
      setPages(safeReservation.pathPages)
    }
  }, [safeReservation])

  useEffect(() => {
    setIsLoading(true)
    getInvalidBirthdatesConfigurations()
      .then(res => {
        setInvalidBirthdates(res)
        setIsLoading(false)
      }).catch(e => {
        setIsLoading(false)
      })
  }, [])

  function handleOpenExtrasClick() {
    props.history.push('/review-reservation-extras')
  }

  function goToNextPage() {
    if (safeReservation.hasCheckIn) {
      return;
    }
    setDriverInfoHasClickedBack(false)
    setDriverInfoEditMode(false)
    props.history.push(flowNextRoute(props.match.path))
  }

  function getStationName(stationId) {
    const station = stationsConfigurations.find(s => s.stationId === stationId)
    const name = station ? t(station.name) : `Station ${stationId}`
    return name 
  }

  return (
    <div className='page-layout'>
      <div className="grow">
        <div className={`main-frame-resumo sua-reserva ${isSafari()? 'safari' : ''}`} style={{ gridAutoRows: 'max-content', gap: '3rem', height: '100%' }}>
          <div className="container">
            <div className='hide-mobile'>
              <ReviewBanner
                onLogoClick={() => props.history.push('/start')}
                logoImgSrc={require(`../../assets/images/logo.png`)}
                groupId={safeReservation.GroupID}
                groupType={groupInfo.type}
                groupImgSrc={groupsConfigurations[safeReservation.GroupID] && groupsConfigurations[safeReservation.GroupID]?.imageUrl}
                driverName={getDriversFirstName(safeReservation.DriverName)}
                reference={safeReservation.Reference}
              />
            </div>
            <ReviewReservationBanner
              onLogoClick={() => props.history.push('/start')}
              logoImgSrc={require(`../../assets/images/logo.png`)}
              groupId={safeReservation.GroupID}
              groupType={groupInfo.type}
              groupImgSrc={groupsConfigurations[safeReservation.GroupID] && groupsConfigurations[safeReservation.GroupID]?.imageUrl}
              driverName={getDriversFirstName(safeReservation.DriverName)}
              reference={safeReservation.Reference}
            />
            <ReviewHero handleClick={goToNextPage} hasCheckIn={safeReservation.hasCheckIn} />
          </div>

          <ReviewLine text={t('mobileResReviewLine')} />

          <div className="container">
            <div className='hide-mobile'>
              <ReviewVehicleProperties
                seats={groupInfo.seats}
                consumption={groupsConfigurations[safeReservation.GroupID] && groupsConfigurations[safeReservation.GroupID]?.consumption + ` (${t('vehicles-' + groupInfo.fuel, '')})`}
                fuel={groupInfo.fuel}
                doors={groupInfo.doors}
                bags={groupInfo.bags}
                handbags={groupInfo.handbags}
                transmission={groupInfo.transmission}
                displayExcess={appFlowConfigs?.showExcessValue || reservation.isExclusiveReservation}
                excessForExtras={getExcessForExtras(reservationExtras)}
                localizationAssets={localizationAssets}
              />
            </div>
            <div className='hide-mobile'>
              <ReviewStations
                pickupStation={getStationName(safeReservation.PickupStationID)}
                pickupDate={moment(safeReservation.PickupDate, 'YYYY-MM-DD HH:mm').locale(i18n.language)?.format('ddd D MMM / HH:mm')}
                dropOffStation={getStationName(safeReservation.DropOffStationID)}
                dropOffDate={moment(safeReservation.DropOffDate, 'YYYY-MM-DD HH:mm').locale(i18n.language)?.format('ddd D MMM / HH:mm')}
              >
                <div className="col-12 col-lg-4 board-background text-center p-3 mb-4">
                  <h3 className="color-green text-uppercase">{t('reservationOverview')}</h3>
                  <div className="row justify-content-end">
                    <div className="block-value col-5 d-flex align-items-center justify-content-center">
                      <div><img src={require("../../assets/images/ico-check.png")} alt="" width="20" /></div>
                      <span className="pl-2">{t('dayCount', { count: safeReservation.raQuote?.nrDays })}</span>
                    </div>
                    <div className="col-7">
                      <div onClick={handleOpenExtrasClick} className="btn btn-green text-uppercase"><b>{t('included')}</b></div>
                    </div>
                  </div>
                </div>
              </ReviewStations>
            </div>

            <div className='hide-desktop review-split-section review-margin--b'>
              <ReviewStationsDetails
                pickupStation={getStationName(safeReservation.PickupStationID)}
                pickupDate={moment(safeReservation.PickupDate, 'YYYY-MM-DD HH:mm').locale(i18n.language)?.format('ddd D MMM / HH:mm')}
                dropOffStation={getStationName(safeReservation.DropOffStationID)}
                dropOffDate={moment(safeReservation.DropOffDate, 'YYYY-MM-DD HH:mm').locale(i18n.language)?.format('ddd D MMM / HH:mm')}
              />
              <ReviewVehicleImage
                groupImgSrc={groupsConfigurations[safeReservation.GroupID] && groupsConfigurations[safeReservation.GroupID]?.imageUrl}
              />
            </div>

            <div className='hide-desktop review-split-section review-margin--b'>
              <ReviewVehicleDetails
                seats={groupInfo.seats}
                consumption={groupsConfigurations[safeReservation.GroupID] && groupsConfigurations[safeReservation.GroupID]?.consumption + ` (${t('vehicles-' + groupInfo.fuel, '')})`}
                doors={groupInfo.doors}
                bags={groupInfo.bags}
                fuel={groupInfo.fuel}
                handbags={groupInfo.handbags}
                transmission={groupInfo.transmission}
                displayExcess={appFlowConfigs?.showExcessValue || reservation.isExclusiveReservation}
                localizationAssets={localizationAssets}
                excessForExtras={getExcessForExtras(reservationExtras)}
              />
              <ReviewVehicleGroup
                groupId={safeReservation.GroupID}
                groupType={groupInfo.type}
              />
            </div>

            <ReviewInfoLine
              nrDays={safeReservation.raQuote?.nrDays}
              handleOpenExtrasClick={handleOpenExtrasClick}
            />
          </div>
        </div>
      </div>
      <ReservationReviewFooter
        prevHidden={true}
        label={safeReservation.hasCheckIn ? '' :
          safeReservation.salesOnly ? t('reservationSalesFooterText') : t('reservationFooterText')}
        handlePrevClick={() => props.history.goBack()}
        handleNextClick={goToNextPage}
        nextDisabled={isLoading}
        nextHidden={safeReservation.hasCheckIn}
      />
    </div>
  )
}

const PAGE_ID = 5
export default withLang(TrackingPage(ReviewReservationPage, 60))

export function ReservationReviewFooter({ handleNextClick, handlePrevClick, prevHidden, nextHidden, label, nextDisabled }) {
  return (
    <div className="footer" onClick={nextDisabled ? null : handleNextClick}>
      <div className="navbar">
        <div onClick={handlePrevClick} className={`prev ${prevHidden ? 'hidden' : ''}`}><img src={require(`../../assets/images/btn-prev-2.png`)} alt="Back" /></div>
        <div className="text-center footer__total">{label}</div>
        <div className={`next  ${nextHidden ? 'hidden' : 'footer-cta--anim'}`}><img src={nextDisabled ? require(`../../assets/images/btn-next-2.png`) : require(`../../assets/images/btn-next-2-active.png`)} alt='Next' /></div>
      </div>
    </div>
  )
}

function ReviewReservationBanner({
  onLogoClick,
  displayLogo = true,
  logoImgSrc,
  groupImgSrc,
  groupId,
  groupType,
  driverName,
  reference,
  display
}) {
  const { t } = useTranslation();

  return (
    <div className="hide-desktop resumo-header row banner-height">
      <div className="col-6 pr-0 ">
        {displayLogo &&
          <div className='logo' onClick={onLogoClick}>
            <img src={logoImgSrc} alt="Guerin" className="img-fluid pt-3 pb-3" />
          </div>
        }
      </div>
      <div className="col-6 text-right">
        <div className="greet">
          <span className="name d-block"><b>{t('hi')} {driverName}</b></span>
          <small>{t('thisIsYourReservation')} {reference}</small>
        </div>
      </div>
    </div>
  )
}

function ReviewHero({ handleClick, hasCheckIn }) {
  const { t } = useTranslation();
  return (
    <div className='hide-desktop review-hero'>
      <div className='review-hero__title'>{t('mobileResReviewHeader')}</div>
      <div className='review-hero__content'>
        <div className='review-hero__content-list'>
          <div className='review-hero__content-list-item'><img width={20} src={require("../../assets/images/ico-check.png")} alt='X' /><span>{t('mobileResReviewAdvantage1')}</span></div>
          <div className='review-hero__content-list-item'><img width={20} src={require("../../assets/images/ico-check.png")} alt='X' /><span>{t('mobileResReviewAdvantage2')}</span></div>
          <div className='review-hero__content-list-item'><img width={20} src={require("../../assets/images/ico-check.png")} alt='X' /><span>{t('mobileResReviewAdvantage3')}</span></div>
        </div>
        {hasCheckIn ? null : 
          <div className='review-hero__content-btn' onClick={handleClick}><span>{t('mobileResReviewHeaderBtn')}</span></div>
        }
      </div>
      {hasCheckIn ? null : 
        <div className='review-hero__sub-title'>{t('mobileResReviewSubHeader1')} <span className='bold' onClick={handleClick}>{t('mobileResReviewSubHeader2')}</span></div>
      }
    </div>
  )
}

function ReviewLine({ text }) {
  return (
    <div className='hide-desktop review-line'>
      {text}
    </div>
  )
}

function ReviewStationsDetails({ pickupStation, pickupDate, dropOffStation, dropOffDate }) {
  const { t } = useTranslation();
  return (
    <div className="">
      <div className="">
        <div className="out w-100 color-green"><b>{t('pickup')}</b></div>
        <p className="pt-2">{pickupStation}<br />{pickupDate}</p>
      </div>
      <div className="">
        <div className="out w-100 color-green"><b>{t('dropoff')}</b></div>
        <p style={{ marginBottom: '0px' }}>{dropOffStation}<br />{dropOffDate}</p>
      </div>
    </div>
  )
}

function ReviewVehicleImage({ groupImgSrc }) {
  return (
    <div className='review-vehicle'>
      <img src={groupImgSrc} alt='' />
    </div>
  )
}

function ReviewVehicleDetails({ fuel, localizationAssets, seats, consumption, displayExcess, excessForExtras, doors, bags, handbags, transmission, safetyDeposit }) {
  const { t } = useTranslation();
  
  const [isOpen, setIsOpen] = useState(false)

  useDisableBodyScroll(isOpen)

  return (
    <div>
      <div className='review-vehicle-details-btn' onClick={() => setIsOpen(v => !v)}>{t('mobileResReviewVehicleDetails')}</div>
      <div className={`review-vehicle-details__popup ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(false)}>
        <div className='review-vehicle-details__popup-content' onClick={e => e.stopPropagation()}>
          <ReviewVehicleProperties
            seats={seats}
            consumption={consumption}
            doors={doors}
            bags={bags}
            handbags={handbags}
            transmission={transmission}
            displayExcess={displayExcess}
            excessForExtras={excessForExtras}
            fuel={fuel}
            localizationAssets={localizationAssets}
            style={{ margin: '0px' }}
          />
        </div>
        <img className='review-vehicle-details__popup-close' src={require('../../assets/images/btn-close-orange.png')} />
      </div>
    </div>
  )
}

function ReviewVehicleGroup({ groupId, groupType }) {
  const { t } = useTranslation()
  return (
    <div className='review-vehicle-group'>
      <div>{t('group')} {groupId}</div>
      <div className='group'>{groupType}</div>
      <div>{t('orSimilar')}</div>
    </div>
  )
}

function ReviewInfoLine({ handleOpenExtrasClick, nrDays }) {
  const { t } = useTranslation()
  return (
    <div className="hide-desktop board-background review-info-line">
      <h3 style={{ margin: '0', fontSize: '13px' }} className="color-green text-uppercase bold">{t('reservationOverview')}</h3>
      <div style={{ width: '63px' }} className="d-flex align-items-center justify-content-center">
        <div><img style={{ borderRadius: '50%' }} src={require("../../assets/images/ico-check.png")} alt="" width="20" /></div>
        <span className="pl-2">{t('dayCount', { count: nrDays })}</span>
      </div>
      <div className="">
        <div style={{ fontSize: '13px' }} onClick={handleOpenExtrasClick} className="btn btn-green text-uppercase review-info-line-btn"><b>{t('included')}</b></div>
      </div>
    </div>
  )
}